export const theme = {
  red: "#cf2533",
  darkBlue: "#132743",
  white: "#ffffff",
}
